import { Component, ViewChild } from '@angular/core';
import { Tabs, TabsModule } from 'primeng/tabs';
import { itemsReportesPermisos } from 'src/app/reportes/componentes/reporte-clientes-anio/presentacion/bandeja-cliente-anio/bandeja-cliente-anio.component';
import { StorageService } from 'src/app/services/storage.service';
import { ReporteComparativoClienteEtaComponent } from '../../comercial/componentes/reporte-comparativo-cliente-eta/reporte-comparativo-cliente-eta.component';
import { ReporteParetoVendedorComponent } from '../../comercial/componentes/reporte-pareto-vendedor/reporte-pareto-vendedor.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-bandeja-reportes-planeamiento',
    standalone: true,
    imports: [
        CommonModule,
        TabsModule,
        ReporteComparativoClienteEtaComponent,
        ReporteParetoVendedorComponent
    ],
    templateUrl: './bandeja-reportes-planeamiento.component.html',
    styleUrl: './bandeja-reportes-planeamiento.component.css'
})
export class BandejaReportesPlaneamientoComponent {
  constructor(
    private readonly storage: StorageService
  ) { }

  activeTab: number = 0;
  subTab: number = 0;

  permisos: itemsReportesPermisos[] = []
  ngOnInit(): void {
    const rol = this.storage.get("rol")

    switch (rol) {
      case "1":
        this.permisos = [
          { header: "Comercial", status: true },
          { header: "Operaciones", status: true },
          { header: "Finanzas", status: true },
          { header: "Sistemas", status: true },
        ]
        break;
      case "1034":
        this.permisos = [
          { header: "Operaciones", status: true },
        ]
        break;
      default:
        this.permisos = []
        break;
    }
  }

  @ViewChild('TabComercial') TabComercial: Tabs;
  @ViewChild('TabOperaciones') TabOperaciones: Tabs;
  @ViewChild('TabFinanzas') TabFinanzas: Tabs;
  @ViewChild('TabSistemas') TabSistemas: Tabs;
  ngAfterViewInit() {
    // const headerComercial = (this.TabComercial.value.header).toString();
    // const headerOperaciones = (this.TabOperaciones.tabs[0].header).toString();
    // const headerFinanzas = (this.TabFinanzas.tabs[0].header).toString();
    // const headerSistemas = (this.TabSistemas.tabs[0].header).toString();

    // if (!this.hasLoadedComercial[headerComercial]) {
    //   this.hasLoadedComercial[headerComercial] = true;
    // }

    // if (!this.hasLoadedOperaciones[headerOperaciones]) {
    //   this.hasLoadedOperaciones[headerOperaciones] = true;
    // }

    // if (!this.hasLoadedFinanzas[headerFinanzas]) {
    //   this.hasLoadedFinanzas[headerFinanzas] = true;
    // }

    // if (!this.hasLoadedSistemas[headerSistemas]) {
    //   this.hasLoadedSistemas[headerSistemas] = true;
    // }
  }

  permisoActivo(menu: string): boolean {
    return this.permisos.some(p => p.header === menu && p.status);
  }

  activeIndex: number = 0
  hasLoaded: boolean[] = Array(9).fill(false);
  hasLoadedComercial: boolean[] = Array(9).fill(false);
  hasLoadedOperaciones: boolean[] = Array(9).fill(false);
  hasLoadedFinanzas: boolean[] = Array(9).fill(false);
  hasLoadedSistemas: boolean[] = Array(9).fill(false);

  onTabChange(event: any) {
    const header = (event.originalEvent.currentTarget.innerText).toString();

    if (!this.hasLoaded[header]) {
      this.hasLoaded[header] = true;
    }

  }

  onChangeTab(event: any, tipo: string) {
    if (tipo == "comercial") {
      const header = (event.originalEvent.currentTarget.innerText).toString();

      if (!this.hasLoadedComercial[header]) {
        this.hasLoadedComercial[header] = true;
      }
    }
    if (tipo == "operaciones") {
      const header = (event.originalEvent.currentTarget.innerText).toString();

      if (!this.hasLoadedOperaciones[header]) {
        this.hasLoadedOperaciones[header] = true;
      }
    }
    if (tipo == "finanzas") {
      const header = (event.originalEvent.currentTarget.innerText).toString();

      if (!this.hasLoadedFinanzas[header]) {
        this.hasLoadedFinanzas[header] = true;
      }
    }
    if (tipo == "sistemas") {
      const header = (event.originalEvent.currentTarget.innerText).toString();

      if (!this.hasLoadedSistemas[header]) {
        this.hasLoadedSistemas[header] = true;
      }
    }
  }

  requestNotificationPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        console.log("Permiso de notificación:", permission);
      });
    } else {
      console.log("Las notificaciones no son compatibles con este navegador.");
    }
  }

  showNotification() {
    if (Notification.permission === 'granted') {
      new Notification("Nueva Notificación", {
        body: "Se genero una nueva requisición.",
       // icon: "https://example.com/icon.png" // URL de un ícono opcional
      });
    } else {
      console.log("No tienes permisos para mostrar notificaciones.");
    }
  }

}
